import React, { useEffect } from "react"
import { Button, Typography, Stack } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import ReplayIcon from "@mui/icons-material/Replay"
import { COLORS } from "../../../utils"
import { getCookingDelaysNotificationCountSelector, getCookingDelaysPSEsSelector, getCookingDelaysReloadedPSEsSelector } from "../../../reducers/Alerts/alerts"
import CookingDelaysCard from "./CookingDelaysCard"
import { addReloadedCookingDelaysAlerts, getCookingDelaysAlertsToReload } from "../../../actions/ProductionSteps/alerts"

const sx = {
    reloadIcon: {
        transform: "scaleX(-1) rotate(-40deg)",
    },
    reloadButton: {
        fontSize: 16,
        textTransform: "none",
        color: COLORS.LABEL_GREY,
        fontWeight: 400
    },
}

const CookingDelays = ({ dateStr }) => {
    const dispatch = useDispatch()

    const productionStepExecutions = useSelector(getCookingDelaysPSEsSelector)
    const reloadedProductionStepExecutions = useSelector(getCookingDelaysReloadedPSEsSelector)
    const notificationCount = useSelector(getCookingDelaysNotificationCountSelector)

    /**
     * Pool function to reload the data every 3 minutes
     * @NOTE: The data is stored in the Redux store, so we can access it from any component
     */
    useEffect(() => {
        const interval = setInterval(() => {
            // This will fetch the data from the server and update the state
            dispatch(getCookingDelaysAlertsToReload(dateStr))
        }, 3 * 60 * 1000) // 3 minutes

        return () => clearInterval(interval) // Cleanup the interval on component unmount
    }, [dispatch, reloadedProductionStepExecutions.length, dateStr])
    /**
     * Update the data table when the user clicks on the reload button
     * @NOTE: It's already in the Redux store (in the pool useEffect), so we just need to update the state
     * @returns 
     */
    const handleReload = () => {
        if (!notificationCount) return
        dispatch(addReloadedCookingDelaysAlerts())
    }
    
    return (
        <>
            {/* -------- header -------- */}
            <Stack direction="row" spacing={2} sx={{ px: 4, py: 2 }} justifyContent="space-between" alignItems="center">
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Retards cuisine
                </Typography>
                <Button
                    variant="text"
                    onClick={handleReload}
                    startIcon={<ReplayIcon sx={sx.reloadIcon} color="primary" />}
                    sx={sx.reloadButton}
                >
                    {notificationCount} changement{notificationCount > 1 ? "s" : ""}
                </Button>
            </Stack>
            {/* -------- Card List -------- */}
            <Stack spacing={4} sx={{ px: 4, py: 2 }}>
                {productionStepExecutions.map((pse, index) => (
                    <CookingDelaysCard key={pse.key + index} pse={pse} />
                ))}
            </Stack>
        </>
    )
}

export default CookingDelays